import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'  // Add this
import router from './router'       // Add this
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

import './scss/app.scss'
import AOS from 'aos'
import 'aos/dist/aos.css'
window.axios = require('axios')

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VueRouter) 

new Vue({
    created () {
        AOS.init({
            once: true
        })
    },
  el: '#app',
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js